import { render, staticRenderFns } from "./providerWinLoseCompanyExportFull.vue?vue&type=template&id=096f816a&lang=pug"
import script from "./providerWinLoseCompanyExportFull.vue?vue&type=script&lang=js"
export * from "./providerWinLoseCompanyExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports